<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.subTypes.form.labels.subTypeName')"
            :is-required="true"
            :error="errors.sub_type"
        >
            <DInput
                id="sub_type"
                v-model="form.sub_type"
                add-input-classes="bg-light"
                maxlength="255"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="getIndex()"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    subType: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    sub_type: props.subType?.sub_type
})

function submitForm () {
    emit('form-submitted', form)
}

function getIndex () {
    return route('products.sub-types.index')
}
</script>
